/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Flex,
  Form,
  Input,
  Menu,
  Select,
  message,
  Image,
  DatePicker,
  Alert,
} from "antd";
import Header from "../components/Header/Header";
import MyText from "../../components/UI/Text/MyText";
import classes from "../global_styles.module.css";
import FormItem from "antd/es/form/FormItem";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import BlueButton from "../../components/UI/Buttons/BlueButton";
import { Link, useNavigate } from "react-router-dom";
import { clrs } from "../../constants/colors";
import Footer from "../components/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import ProfessionService from "../../services/ProfessionService";
import {
  AuditOutlined,
  FileSearchOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  FileDoneOutlined,
  CrownOutlined,
} from "@ant-design/icons";
import ApplicationService from "../../services/ApplicationService";
import HorizontalDivider from "../../components/Divider/HorizontalDivider";
import img1 from "../../images/photo/3x/1.png";
import img2 from "../../images/photo/3x/2.png";
import img3 from "../../images/photo/3x/3.png";
import img1White from "../../images/icon/white/Ресурс 15@3x.png";
import img4 from "../../images/photo/3x/4.png";
import img5 from "../../images/photo/3x/5.png";
import img6 from "../../images/photo/3x/6.png";
import img2White from "../../images/icon/white/B - 77,  plug, electric, electric, cord, charge@3x.png";
import img7 from "../../images/photo/3x/7.png";
import img8 from "../../images/photo/3x/8.png";
import img9 from "../../images/photo/3x/9.png";
import img3White from "../../images/icon/white/Ресурс 5@3x.png";
import img10 from "../../images/photo/3x/10.png";
import img11 from "../../images/photo/3x/11.png";
import img12 from "../../images/photo/3x/12.png";
import img4White from "../../images/icon/white/Ресурс 11@3x.png";
import img13 from "../../images/photo/3x/13.png";
import img14 from "../../images/photo/3x/14.png";
import img15 from "../../images/photo/3x/15.png";
import img5White from "../../images/icon/white/Ресурс 13@3x.png";
import img16 from "../../images/photo/3x/16.png";
import img17 from "../../images/photo/3x/17.png";
import img18 from "../../images/photo/3x/18.png";
import img6White from "../../images/icon/white/Ресурс 8@3x.png";
import img19 from "../../images/photo/3x/19.png";
import img20 from "../../images/photo/3x/20.png";
import img21 from "../../images/photo/3x/21.png";
import img7White from "../../images/icon/white/Ресурс 10@3x.png";
import img22 from "../../images/photo/3x/22.png";
import img23 from "../../images/photo/3x/23.png";
import img24 from "../../images/photo/3x/24.png";
import img8White from "../../images/icon/white/Ресурс 7@3x.png";
import img25 from "../../images/photo/3x/25.png";
import img26 from "../../images/photo/3x/26.png";
import img27 from "../../images/photo/3x/27.png";
import img9White from "../../images/icon/white/Ресурс 14@3x.png";
import img28 from "../../images/photo/3x/28.png";
import img29 from "../../images/photo/3x/29.png";
import img30 from "../../images/photo/3x/30.png";
import img10White from "../../images/icon/white/Ресурс 6@3x.png";
import img31 from "../../images/photo/3x/31.png";
import img32 from "../../images/photo/3x/32.png";
import img33 from "../../images/photo/3x/33.png";
import img11White from "../../images/icon/white/B - 87, blueprint, Architecture, blue print, construction, paper, plan@3x.png";
import img34 from "../../images/photo/3x/34.png";
import img35 from "../../images/photo/3x/35.png";
import img36 from "../../images/photo/3x/36.png";
import img12White from "../../images/icon/white/Ресурс 9@3x.png";
import img37 from "../../images/photo/3x/37.png";
import img38 from "../../images/photo/3x/38.png";
import img39 from "../../images/photo/3x/39.png";
import img13White from "../../images/icon/white/Ресурс 4@3x.png";
import img40 from "../../images/photo/3x/40.png";
import img41 from "../../images/photo/3x/41.png";
import img42 from "../../images/photo/3x/42.png";
import img14White from "../../images/icon/white/Ресурс 12@3x.png";
import img43 from "../../images/photo/3x/43.png";
import img44 from "../../images/photo/3x/44.png";
import img45 from "../../images/photo/3x/45.png";
import img15White from "../../images/icon/white/Ресурс 1@3x.png";
import ThreeImagesLayout from "../Profession/ThreeImagesLayout";
import professions from "../Profession/professions.json";
import InfoItem from "../Profession/InfoItem";
import cl from "../ChooseLanguage/ChooseLanguagePage.module.css";
// eslint-disable-next-line no-unused-vars
import { useTranslation } from "react-i18next";
import UserService from "../../services/UserService";
import { setUserState } from "../../store/slices/userSlice";
import dayjs from "dayjs";
import { Badge, Calendar } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import FormService from "../../services/FormService";
import professions_subs from "../../constants/professions_subs.json";
import CertificatePage from "./CertificatePage";
import profileImgMan from "../../images/man.png";
import profileImgWoman from "../../images/woman.png";

const ProfilePage = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useSelector((state) => state.user);

  const [professionsList, setProfessionsList] = useState([]);

  const [formApplication] = Form.useForm();
  const [formForm] = Form.useForm();

  const [selectedFormProfession, setSelectedFormProfession] = useState(null);

  const [myApplications, setMyApplications] = useState([]);

  const [number, setNumber] = useState("1");

  // const { t } = useTranslation();
  const dispatch = useDispatch();

  const [formProfileSettings] = Form.useForm();

  const [myForm, setMyForm] = useState(null);

  useEffect(() => {
    ProfessionService.getProfessions()
      .then((r) => {
        setProfessionsList(r.data);
      })
      .catch((r) => {});
  }, []);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (user == null && isLoading == false) {
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isLoading]);

  const [currentMenu, setCurrentMenu] = useState("profile");

  function getImages(number) {
    const num = Number(number);

    // Check if the input is a valid number
    if (isNaN(num)) {
      return;
    }

    // Return different arrays of images based on the number
    if (num === 1) {
      return [img1, img2, img3, img1White];
    } else if (num === 2) {
      return [img7, img8, img9, img3White];
    } else if (num === 3) {
      return [img4, img5, img6, img2White];
    } else if (num === 4) {
      return [img10, img11, img12, img4White];
    } else if (num === 5) {
      return [img13, img14, img15, img5White];
    } else if (num === 6) {
      return [img16, img17, img18, img6White];
    } else if (num === 7) {
      return [img19, img20, img21, img7White];
    } else if (num === 8) {
      return [img22, img23, img24, img8White];
    } else if (num === 9) {
      return [img25, img26, img27, img9White];
    } else if (num === 10) {
      return [img28, img29, img30, img10White];
    } else if (num === 11) {
      return [img31, img32, img33, img11White];
    } else if (num === 12) {
      return [img34, img35, img36, img12White];
    } else if (num === 13) {
      return [img37, img38, img39, img13White];
    } else if (num === 14) {
      return [img40, img41, img42, img14White];
    } else if (num === 15) {
      return [img43, img44, img45, img15White];
    }

    // Return an empty array or undefined if the number is not between 1 and 15
    return [];
  }

  function handleOnUpdateProfile() {
    const lastName = formProfileSettings.getFieldValue("lastName");
    const firstName = formProfileSettings.getFieldValue("firstName");
    // const middleName = formProfileSettings.getFieldValue('middleName');
    const contactNumber = formProfileSettings.getFieldValue("contactNumber");
    const birthday = formProfileSettings.getFieldValue("birthday");
    const gender = formProfileSettings.getFieldValue("gender");
    const country = formProfileSettings.getFieldValue("country");
    const city = formProfileSettings.getFieldValue("city");
    const school = formProfileSettings.getFieldValue("school");
    const schoolClass = formProfileSettings.getFieldValue("schoolClass");
    // const expectedGraduationDate = formProfileSettings.getFieldValue('expectedGraduationDate');
    const languageSkills = formProfileSettings.getFieldValue("languageSkills");
    const foreignLanguageSkills = formProfileSettings.getFieldValue(
      "foreignLanguageSkills"
    );

    formProfileSettings
      .validateFields()
      .then(() => {
        message.loading(<IntlMessage id={"loading"} />, 5);
        UserService.updateProfile(
          lastName,
          firstName,
          null,
          contactNumber,
          birthday,
          gender,
          country,
          city,
          school,
          schoolClass,
          null,
          languageSkills,
          foreignLanguageSkills
        )
          .then((result) => {
            // console.log(result.data);
            message.destroy();
            message.success(<IntlMessage id={"success"} />, 5);
            dispatch(setUserState(result.data));
          })
          .catch((result) => {
            message.destroy();
            message.error(<IntlMessage id={"error"} />, 5);
          });
      })
      .catch(() => {});
  }

  function handleOnSendForm() {
    formForm
      .validateFields()
      .then(async () => {
        message.loading(<IntlMessage id={"loading"} />, 5);
        const profKey = formForm.getFieldValue("mainProfession");
        const subProfKey = formForm.getFieldValue("subProfession");

        console.log(profKey, subProfKey);

        const mainProfession = professions_subs.professions.find(
          (p) => p.key === profKey
        );
        const subProfession = mainProfession.subs.find(
          (p) => p.key === subProfKey
        );

        await FormService.createForm(mainProfession.name, subProfession.name)
          .then((result) => {
            // console.log(result.data);
            message.destroy();
            message.success(<IntlMessage id={"success"} />, 5);
            setMyForm(result.data);
          })
          .catch((result) => {
            message.destroy();
            message.error(<IntlMessage id={"error"} />, 5);
          });
      })
      .catch(() => {});
  }

  function renderCell(date) {
    const lastApplication = myApplications[0];

    if (!lastApplication) {
      return <></>;
    }

    const appointmentDateA = new Date(lastApplication?.appointmentDateA);
    const appointmentDateB = new Date(lastApplication?.appointmentDateB);
    const appointmentDateC = new Date(lastApplication?.appointmentDateC);

    const result = [];

    if (date.toLocaleDateString() === appointmentDateA.toLocaleDateString()) {
      result.push(<Badge className="calendar-todo-item-badge" />);
    }

    if (date.toLocaleDateString() === appointmentDateB.toLocaleDateString()) {
      result.push(<Badge className="calendar-todo-item-badge" />);
    }

    if (date.toLocaleDateString() === appointmentDateC.toLocaleDateString()) {
      result.push(<Badge className="calendar-todo-item-badge" />);
    }

    if (result.length > 0) {
      return (
        <Flex align={"center"} justify={"center"} gap={5}>
          {result.map((item, index) => {
            return item;
          })}
        </Flex>
      );
    }

    return <></>;
  }

  const items = [
    {
      label: "Профайл",
      key: "profile",
      icon: <UserOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align={"flex-start"}
          justify={"flex-start"}
          vertical
          gap={20}
        >
          <MyText size={"large"} style={{ paddingLeft: 20 }} strong>
            Профайл
          </MyText>
          <HorizontalDivider />
          {!user?.profile?.isConfirmedEmail && (
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <Alert
                message={
                  "Таны и-мэйл хаяг руу мессеж илгээсэн байна. Таны и-мэйл хаягаа баталгаажуулна уу, үгүй бол та системийг ашиглах боломжтой байх болно."
                }
              />
            </Flex>
          )}
          {!user?.profile?.isFullFilled && (
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <Alert message={"Та профайл-аа бүрэн бөглөнө үү."} />
            </Flex>
          )}
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Овог: </MyText>
            <MyText>{user?.profile?.firstName}</MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Нэр: </MyText>
            <MyText>{user?.profile?.lastName}</MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Холбоо барих дугаар: </MyText>
            <MyText>{user?.profile?.contactNumber}</MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>И-мэйл: </MyText>
            <MyText>{user?.profile?.email}</MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Төрсөн огноо: </MyText>
            <MyText>
              {user?.profile?.birthday &&
                new Date(user?.profile?.birthday).toLocaleDateString()}
            </MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Хүйс: </MyText>
            <MyText>{user?.profile?.gender === true && "Эрэгтэй"}</MyText>
            <MyText>{user?.profile?.gender === false && "Эмэгтэй"}</MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Улс: </MyText>
            <MyText>{user?.profile?.country}</MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Хот/Аймаг: </MyText>
            <MyText>{user?.profile?.city}</MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Сургууль: </MyText>
            <MyText>{user?.profile?.school}</MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Анги: </MyText>
            <MyText>{user?.profile?.schoolClass}</MyText>
          </Flex>
          {/*<Flex style={{width: "100%", paddingLeft: 20, paddingRight: 20}} align={"center"} justify={"flex-start"} gap={20}>*/}
          {/*    <MyText strong>Хүлээгдэж буй сургуулийн гэрчилгээ гарах: </MyText>*/}
          {/*    <MyText>{user?.profile?.expectedGraduationDate && new Date(user?.profile?.expectedGraduationDate).toLocaleDateString()}</MyText>*/}
          {/*</Flex>*/}
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Төрөлх хэл: </MyText>
            <MyText>{user?.profile?.languageSkills}</MyText>
          </Flex>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <MyText strong>Гадаад хэл: </MyText>
            <MyText>{user?.profile?.foreignLanguageSkills}</MyText>
          </Flex>
        </Flex>
      ),
    },
    {
      label: "Мэргэжлийн чиглэл",
      key: "professions",
      icon: <FileDoneOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align={"flex-start"}
          justify={"flex-start"}
          vertical
          gap={20}
        >
          <MyText size={"large"} style={{ paddingLeft: 20 }} strong>
            Мэргэжлийн чиглэл
          </MyText>
          <HorizontalDivider />
          <Flex
            style={{
              width: "100%",
              position: "relative",
              paddingLeft: 20,
              paddingRight: 20,
            }}
            align={"center"}
            justify={"flex-start"}
          >
            <Select
              defaultValue={number}
              onChange={(v) => {
                setNumber(v);
              }}
              style={{
                width: "100%",
                textAlign: "center",
              }}
              rootClassName={cl.select}
              dropdownStyle={{
                textAlign: "center",
                borderRadius: 0,
              }}
              suffixIcon={null}
              options={[
                {
                  value: "1",
                  label: "БАРИЛГА, АРХИТЕКТУР, ХЭМЖИЛ ЗҮЙ",
                },
                {
                  value: "2",
                  label: "ЦАХИЛГААН, ЭЛЕКТРОНИК",
                },
                {
                  value: "3",
                  label: "ҮЙЛЧИЛГЭЭ ҮЗҮҮЛЭХ",
                },
                {
                  value: "4",
                  label: "ЭРҮҮЛ МЭНД",
                },
                {
                  value: "5",
                  label: "МЭДЭЭЛЛИЙН ТЕХНОЛОГИ, КОМПЬЮТЕР",
                },
                {
                  value: "6",
                  label: "УРЛАГ, СОЁЛ, ДИЗАЙН",
                },
                {
                  value: "7",
                  label: "ХӨДӨӨ АЖ АХУЙ, БАЙГАЛЬ, ХҮРЭЭЛЭН БУЙ ОРЧИН",
                },
                {
                  value: "8",
                  label: "ХЭВЛЭЛ МЭДЭЭЛЭЛ",
                },
                {
                  value: "9",
                  label: "МЕТАЛЛ БА МЕХАНИК ИНЖЕНЕРЧЛЭЛ",
                },
                {
                  value: "10",
                  label: "БАЙГАЛИЙН ШИНЖЛЭХ УХААН",
                },
                {
                  value: "11",
                  label: "ҮЙЛДВЭРЛЭЛ БА БЭЛЭН БҮТЭЭГДЭХҮҮН",
                },
                {
                  value: "12",
                  label: "НИЙГМИЙН ХАРИЛЦАА БА СУРГАН ХҮМҮҮЖҮҮЛЭХ УХААН",
                },
                {
                  value: "13",
                  label: "ТЕХНИК, ТЕХНОЛОГИ",
                },
                {
                  value: "14",
                  label: "ТЭЭВЭР, ЛОЖИСТИК",
                },
                {
                  value: "15",
                  label: "ЭДИЙН ЗАСАГ, ЗАХИРГАА",
                },
              ]}
            />
          </Flex>
          <Flex
            style={{
              width: "100%",
              position: "relative",
              paddingLeft: 20,
              paddingRight: 20,
            }}
            vertical
            align={"center"}
            justify={"flex-start"}
          >
            <Flex
              style={{ width: "100%", position: "relative", paddingBottom: 50 }}
              vertical
              gap={50}
              align={"center"}
              justify={"flex-start"}
            >
              <Flex
                style={{ width: "100%", maxWidth: 1440, position: "relative" }}
                wrap={"wrap"}
                gap={20}
                align={"flex-start"}
                justify={"center"}
              >
                <ThreeImagesLayout
                  img1={getImages(number)[0]}
                  img2={getImages(number)[1]}
                  img3={getImages(number)[2]}
                />
              </Flex>
              <Flex
                style={{ width: "100%", maxWidth: 1440, position: "relative" }}
                wrap={"wrap"}
                gap={20}
                align={"flex-start"}
                justify={"center"}
              >
                <Flex
                  style={{
                    width: "100%",
                    padding: 10,
                    backgroundColor: clrs.blackerBlue,
                  }}
                  align={"center"}
                  justify={"flex-start"}
                  gap={10}
                >
                  <MyText strong size={"large"} style={{ color: "white" }}>
                    {professions[`${number}`].name}{" "}
                  </MyText>
                  <Flex
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: "100%",
                      backgroundColor: clrs.blackerBlue,
                      padding: 5,
                      position: "absolute",
                      right: 10,
                    }}
                    align={"center"}
                    justify={"center"}
                  >
                    <Image
                      preview={false}
                      src={getImages(number)[3]}
                      width={45}
                    />
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                style={{ width: "100%", maxWidth: 1440, position: "relative" }}
                wrap={"wrap"}
                align={"flex-start"}
                justify={"flex-start"}
              >
                {professions[`${number}`].upperTexts.map((upperText, i) => {
                  return (
                    <MyText
                      key={new Date() + i + "upperText"}
                      style={{ textAlign: "justify", color: clrs.blackerBlue }}
                    >
                      {upperText}
                    </MyText>
                  );
                })}
              </Flex>
              {professions[`${number}`].items.map((item, i) => {
                return (
                  <InfoItem
                    key={new Date() + i}
                    number={item.number}
                    textUp={item.upText}
                    textCenter={item.centerText}
                    textBottom={item.bottomText}
                  />
                );
              })}
            </Flex>
            <Flex
              style={{ width: "100%", maxWidth: 1440, position: "relative" }}
              vertical
              align={"flex-start"}
              justify={"flex-start"}
            >
              {professions[`${number}`].bottomTexts.map((bottomText, i) => {
                return (
                  <MyText
                    key={new Date() + i + "upperText"}
                    style={{ textAlign: "justify", color: clrs.blackerBlue }}
                  >
                    {bottomText}
                  </MyText>
                );
              })}
            </Flex>
          </Flex>
        </Flex>
      ),
    },
    {
      type: "divider",
    },
    {
      label: "Мэргэжил сонголт",
      key: "application",
      icon: <FileSearchOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align={"flex-start"}
          justify={"flex-start"}
          vertical
          gap={20}
        >
          <MyText size={"large"} style={{ paddingLeft: 20 }} strong>
            Мэргэжил сонголт
          </MyText>
          <HorizontalDivider />
          <Flex
            style={{
              width: "100%",
              position: "relative",
              paddingLeft: 20,
              paddingRight: 20,
            }}
            gap={50}
            vertical
            align={"center"}
            justify={"center"}
          >
            <Form
              form={formApplication}
              className={classes.form}
              style={{ width: "100%", position: "relative" }}
            >
              <Flex
                style={{ width: "100%", position: "relative" }}
                gap={20}
                align={"center"}
                justify={"center"}
              >
                <Flex
                  style={{
                    width: 300,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <MyText>Сонголт 1</MyText>
                </Flex>
                <Flex
                  style={{
                    width: 300,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <FormItem
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id={"requiredField"} />,
                      },
                    ]}
                    className={classes.formInputBlock}
                    name="professionPriorityA"
                  >
                    <Select
                      disabled={myApplications[0]?.id != null}
                      style={{
                        width: "100%",
                      }}
                      options={professionsList.map((profession) => {
                        return {
                          value: profession.id,
                          label: profession.name,
                        };
                      })}
                    />
                  </FormItem>
                </Flex>
              </Flex>
              <Flex
                style={{ width: "100%", position: "relative" }}
                gap={20}
                align={"center"}
                justify={"center"}
              >
                <Flex
                  style={{
                    width: 300,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <MyText>Сонголт 2</MyText>
                </Flex>
                <Flex
                  style={{
                    width: 300,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <FormItem
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id={"requiredField"} />,
                      },
                    ]}
                    className={classes.formInputBlock}
                    name="professionPriorityB"
                  >
                    <Select
                      style={{
                        width: "100%",
                      }}
                      disabled={myApplications[0]?.id != null}
                      options={professionsList.map((profession) => {
                        return {
                          value: profession.id,
                          label: profession.name,
                        };
                      })}
                    />
                  </FormItem>
                </Flex>
              </Flex>
              <Flex
                style={{ width: "100%", position: "relative" }}
                gap={20}
                align={"center"}
                justify={"center"}
              >
                <Flex
                  style={{
                    width: 300,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <MyText>Сонголт 3</MyText>
                </Flex>
                <Flex
                  style={{
                    width: 300,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <FormItem
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id={"requiredField"} />,
                      },
                    ]}
                    className={classes.formInputBlock}
                    name="professionPriorityC"
                  >
                    <Select
                      style={{
                        width: "100%",
                      }}
                      disabled={myApplications[0]?.id != null}
                      options={professionsList.map((profession) => ({
                        value: profession.id,
                        label: profession.name,
                      }))}
                    />
                  </FormItem>
                </Flex>
              </Flex>
            </Form>
            <BlueButton
              disabled={myApplications[0]?.id != null}
              onClick={handleCreateApplication}
            >
              Илгээх
            </BlueButton>
          </Flex>
        </Flex>
      ),
    },
    {
      label: "Миний сонголт",
      key: "my-application",
      icon: <AuditOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align={"flex-start"}
          justify={"flex-start"}
          vertical
          gap={20}
        >
          <MyText size={"large"} style={{ paddingLeft: 20 }} strong>
            Миний сонголт
          </MyText>
          <HorizontalDivider />
          <Flex
            style={{
              width: "100%",
              position: "relative",
              paddingLeft: 20,
              paddingRight: 20,
            }}
            gap={50}
            vertical
            align={"center"}
            justify={"flex-start"}
          >
            <Flex
              style={{ width: "100%", height: 452, position: "relative" }}
              align={"flex-start"}
              justify={"center"}
              gap={50}
            >
              <Flex
                style={{ width: "50%", padding: 20, backgroundColor: "white" }}
                align={"center"}
                justify={"center"}
              >
                <Calendar compact bordered renderCell={renderCell} />
              </Flex>
              <Flex
                style={{
                  width: "50%",
                  padding: "32px 20px 20px 20px",
                  height: "100%",
                  backgroundColor: "white",
                  position: "relative",
                }}
                gap={20}
                vertical
                align={"center"}
                justify={"flex-start"}
              >
                <MyText strong size={"large"}>
                  Мэргэжил сонголт
                </MyText>
                <Flex
                  style={{ width: "100%", height: "100%" }}
                  align={"center"}
                  justify={"center"}
                  vertical
                  gap={40}
                >
                  <Flex
                    style={{ width: "100%" }}
                    align={"center"}
                    justify={"center"}
                    vertical
                  >
                    <MyText
                      size={"small"}
                      style={{ color: clrs.whiterBlacker }}
                    >
                      Сонголт 1
                    </MyText>
                    <MyText style={{ textAlign: "center" }}>
                      {myApplications[0]?.professionPriorityA &&
                      myApplications[0].status !== "REJECTED"
                        ? myApplications[0]?.professionPriorityA.name
                        : "_"}
                    </MyText>
                  </Flex>
                  <Flex
                    style={{ width: "100%" }}
                    align={"center"}
                    justify={"center"}
                    vertical
                  >
                    <MyText
                      size={"small"}
                      style={{ color: clrs.whiterBlacker }}
                    >
                      Сонголт 2
                    </MyText>
                    <MyText style={{ textAlign: "center" }}>
                      {myApplications[0]?.professionPriorityB &&
                      myApplications[0].status !== "REJECTED"
                        ? myApplications[0]?.professionPriorityB.name
                        : "_"}
                    </MyText>
                  </Flex>
                  <Flex
                    style={{ width: "100%" }}
                    align={"center"}
                    justify={"center"}
                    vertical
                  >
                    <MyText
                      size={"small"}
                      style={{ color: clrs.whiterBlacker }}
                    >
                      Сонголт 3
                    </MyText>
                    <MyText style={{ textAlign: "center" }}>
                      {myApplications[0]?.professionPriorityC &&
                      myApplications[0].status !== "REJECTED"
                        ? myApplications[0]?.professionPriorityC.name
                        : "_"}
                    </MyText>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
            {/* <Flex
              style={{
                width: "100%",
                padding: "30px 20px",
                backgroundColor: "#29a0e1",
              }}
              vertical
              gap={10}
              align={"center"}
              justify={"center"}
            >
              {myApplications.length > 0 &&
              myApplications[0].status !== "PENDING" ? (
                <>
                  <div style={{ textAlign: "center" }}>
                    <MyText
                      strong
                      style={{
                        color: clrs.whiter,
                        fontSize: "1.5rem",
                      }}
                    >
                      Та доорх хуваарийн дагуу сонгосон мэргэжлийн чиглэлийн
                      сургалтад хамрагдана уу!!
                    </MyText>
                  </div>
                  <Card
                    title={
                      myApplications[0]?.professionPriorityA?.name || "Мэргэжил"
                    }
                    extra={
                      myApplications[0]?.linkA && (
                        <a
                          href={myApplications[0].linkA}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "underline",
                            color: "#1677ff",
                          }}
                        >
                          Сургалтын холбоос
                        </a>
                      )
                    }
                  >
                    <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                      {myApplications[0]?.appointmentDateA
                        ? new Date(
                            myApplications[0].appointmentDateA
                          ).toLocaleString()
                        : ""}
                    </p>
                    <p>
                      {myApplications[0]?.addressA && (
                        <div>{myApplications[0].addressA}</div>
                      )}
                    </p>
                  </Card>
                  <Card
                    title={
                      myApplications[0]?.professionPriorityB?.name || "Мэргэжил"
                    }
                    extra={
                      myApplications[0]?.linkB && (
                        <a
                          href={myApplications[0].linkB}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "underline",
                            color: "#1677ff",
                          }}
                        >
                          Сургалтын холбоос
                        </a>
                      )
                    }
                  >
                    <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                      {myApplications[0]?.appointmentDateB
                        ? new Date(
                            myApplications[0].appointmentDateB
                          ).toLocaleString()
                        : ""}
                    </p>
                    <p>
                      {myApplications[0]?.addressB && (
                        <div>{myApplications[0].addressB}</div>
                      )}
                    </p>
                  </Card>
                  <Card
                    title={
                      myApplications[0]?.professionPriorityC?.name || "Мэргэжил"
                    }
                    extra={
                      myApplications[0]?.linkC && (
                        <a
                          href={myApplications[0].linkC}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "underline",
                            color: "#1677ff",
                          }}
                        >
                          Сургалтын холбоос
                        </a>
                      )
                    }
                  >
                    <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                      {myApplications[0]?.appointmentDateC
                        ? new Date(
                            myApplications[0].appointmentDateC
                          ).toLocaleString()
                        : ""}
                    </p>
                    <p>
                      {myApplications[0]?.addressC && (
                        <div>{myApplications[0].addressC}</div>
                      )}
                    </p>
                  </Card>
                </>
              ) : (
                <MyText strong style={{ color: clrs.whiter }}>
                  Танд одоогоор мэргэжлийн сургалтын тов/цагийн хуваарь
                  ирүүлээгүй байна.
                </MyText>
              )}
            </Flex> */}
          </Flex>
        </Flex>
      ),
    },
    {
      label: "Сонгосон мэргэжил",
      key: "form",
      icon: <FileSearchOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align={"flex-start"}
          justify={"flex-start"}
          vertical
          gap={20}
        >
          <MyText size={"large"} style={{ paddingLeft: 20 }} strong>
            Сонгосон мэргэжил
          </MyText>
          <HorizontalDivider />
          {!myForm && (
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <Alert
                message={
                  "Анхааруулга! Сонгосон мэргэжлийн чиглэл хэсгийг бөглөхөөс өмнө урьдчилан боловсруулсан бүх танилцуулга руу орж /Мэргэжлийн чиглэл/, уншиж судлаарай. Мэргэжил сонголт хийгээгүй бол Сонгосон мэргэжлийн чиглэл хадгалах боломжгүй."
                }
              />
            </Flex>
          )}
          {myForm ? (
            <Flex
              style={{
                width: "100%",
                position: "relative",
                paddingLeft: 20,
                paddingRight: 20,
              }}
              gap={20}
              vertical
              align={"center"}
              justify={"center"}
            >
              <Flex
                style={{ width: "100%", position: "relative" }}
                gap={20}
                align={"center"}
                justify={"center"}
              >
                <Flex
                  style={{
                    width: 300,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <MyText strong>Үндсэн мэргэжлийн чиглэл</MyText>
                </Flex>
                <Flex
                  style={{
                    width: 300,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                    textAlign: "center",
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  {myForm?.mainProfession}
                </Flex>
              </Flex>
              <Flex
                style={{ width: "100%", position: "relative" }}
                gap={20}
                align={"center"}
                justify={"center"}
              >
                <Flex
                  style={{
                    width: 300,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <MyText strong>Мэргэжлийн жагсаалт</MyText>
                </Flex>
                <Flex
                  style={{
                    width: 600,
                    backgroundColor: "white",
                    height: 100,
                    padding: 25,
                    textAlign: "center",
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  {myForm?.subProfession}
                </Flex>
              </Flex>
            </Flex>
          ) : (
            <Flex
              style={{
                width: "100%",
                position: "relative",
                paddingLeft: 20,
                paddingRight: 20,
              }}
              gap={50}
              vertical
              align={"center"}
              justify={"center"}
            >
              <Form
                form={formForm}
                className={classes.form}
                style={{ width: "100%", position: "relative" }}
              >
                <Flex
                  style={{ width: "100%", position: "relative" }}
                  gap={20}
                  align={"center"}
                  justify={"center"}
                >
                  <Flex
                    style={{
                      width: 300,
                      backgroundColor: "white",
                      height: 100,
                      padding: 25,
                    }}
                    align={"center"}
                    justify={"center"}
                  >
                    <MyText strong>Үндсэн мэргэжлийн чиглэл</MyText>
                  </Flex>
                  <Flex
                    style={{
                      width: 600,
                      backgroundColor: "white",
                      height: 100,
                      padding: 25,
                    }}
                    align={"center"}
                    justify={"center"}
                  >
                    <FormItem
                      rules={[
                        {
                          required: true,
                          message: <IntlMessage id={"requiredField"} />,
                        },
                      ]}
                      className={classes.formInputBlock}
                      name="mainProfession"
                    >
                      <Select
                        style={{
                          width: "100%",
                        }}
                        onChange={(value) => {
                          setSelectedFormProfession(
                            professions_subs.professions.find(
                              (prof) => prof.key === value
                            )
                          );
                          formForm.resetFields(["subProfession"]);
                        }}
                        options={professions_subs.professions.map(
                          (profession) => {
                            return {
                              value: profession.key,
                              label: profession.name,
                            };
                          }
                        )}
                      />
                    </FormItem>
                  </Flex>
                </Flex>
                <Flex
                  style={{ width: "100%", position: "relative" }}
                  gap={20}
                  align={"center"}
                  justify={"center"}
                >
                  <Flex
                    style={{
                      width: 300,
                      backgroundColor: "white",
                      height: 100,
                      padding: 25,
                    }}
                    align={"center"}
                    justify={"center"}
                  >
                    <MyText strong>Мэргэжлийн жагсаалт</MyText>
                  </Flex>
                  <Flex
                    style={{
                      width: 600,
                      backgroundColor: "white",
                      height: 100,
                      padding: 25,
                    }}
                    align={"center"}
                    justify={"center"}
                  >
                    <FormItem
                      rules={[
                        {
                          required: true,
                          message: <IntlMessage id={"requiredField"} />,
                        },
                      ]}
                      className={classes.formInputBlock}
                      name="subProfession"
                    >
                      <Select
                        style={{
                          width: "100%",
                        }}
                        options={selectedFormProfession?.subs.map(
                          (profession) => {
                            return {
                              value: profession.key,
                              label: profession.name,
                            };
                          }
                        )}
                      />
                    </FormItem>
                  </Flex>
                </Flex>
              </Form>
              <BlueButton onClick={handleOnSendForm}>Илгээх</BlueButton>
            </Flex>
          )}
        </Flex>
      ),
    },
    {
      label: "Батламж",
      key: "certificate",
      icon: <CrownOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align="flex-start"
          justify="flex-start"
          vertical
          gap={20}
        >
          <MyText size="large" style={{ paddingLeft: 20 }} strong>
            Батламж
          </MyText>
          <HorizontalDivider />
          <CertificatePage />
        </Flex>
      ),
    },
    {
      type: "divider",
    },
    {
      label: "Тохиргоо",
      key: "settings",
      icon: <SettingOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align={"flex-start"}
          justify={"flex-start"}
          vertical
          gap={20}
        >
          <MyText size={"large"} style={{ paddingLeft: 20 }} strong>
            Тохиргоо
          </MyText>
          <HorizontalDivider />
          <Flex
            style={{
              width: "100%",
              position: "relative",
              paddingLeft: 20,
              paddingRight: 20,
            }}
            align={"center"}
            justify={"flex-start"}
          >
            <Form
              form={formProfileSettings}
              initialValues={{
                lastName: user?.profile?.lastName,
                firstName: user?.profile?.firstName,
                middleName: user?.profile?.middleName,
                contactNumber: user?.profile?.contactNumber,
                birthday:
                  user?.profile?.birthday && dayjs(user?.profile?.birthday),
                gender: user?.profile?.gender,
                country: user?.profile?.country,
                city: user?.profile?.city,
                school: user?.profile?.school,
                schoolClass: user?.profile?.schoolClass,
                // expectedGraduationDate: user?.profile?.expectedGraduationDate && dayjs(user?.profile?.expectedGraduationDate),
                languageSkills: user?.profile?.languageSkills,
                foreignLanguageSkills: user?.profile?.foreignLanguageSkills,
              }}
              className={classes.form}
              style={{ justifyContent: "center" }}
            >
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="firstName"
              >
                <Input
                  rootClassName={classes.formInput}
                  placeholder={"Овог"}
                  defaultValue={user?.profile?.firstName}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="lastName"
              >
                <Input
                  rootClassName={classes.formInput}
                  placeholder={"Нэр"}
                  defaultValue={user?.profile?.lastName}
                />
              </FormItem>
              {/*<FormItem className={classes.formInputBlock} name="middleName">*/}
              {/*    <Input rootClassName={classes.formInput}*/}
              {/*           placeholder={"Эцгийн нэр"}*/}
              {/*           defaultValue={user?.profile?.middleName}*/}
              {/*    />*/}
              {/*</FormItem>*/}
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="contactNumber"
              >
                <Input
                  rootClassName={classes.formInput}
                  placeholder={"Холбоо барих дугаар"}
                  defaultValue={user?.profile?.contactNumber}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="birthday"
              >
                <DatePicker
                  style={{ width: "100%", padding: "10px 15px" }}
                  placeholder={"Төрсөн огноо"}
                  defaultValue={
                    user?.profile?.birthday && dayjs(user?.profile?.birthday)
                  }
                />
              </FormItem>

              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="gender"
              >
                <Select
                  placeholder={"Хүйс"}
                  style={{
                    width: "100%",
                  }}
                  defaultValue={user?.profile?.gender}
                  options={[
                    {
                      value: true,
                      label: "Эрэгтэй",
                    },
                    {
                      value: false,
                      label: "Эмэгтэй",
                    },
                  ]}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="country"
              >
                <Select
                  placeholder={"Улс"}
                  style={{
                    width: "100%",
                  }}
                  defaultValue={user?.profile?.country}
                  options={[
                    {
                      value: "Монгол улс",
                      label: "Монгол улс",
                    },
                    {
                      value: "Казачстан",
                      label: "Казачстан",
                    },
                    {
                      value: "Киргизстан",
                      label: "Киргизстан",
                    },
                    {
                      value: "Украин",
                      label: "Украин",
                    },
                    {
                      value: "Узбекстан",
                      label: "Узбекстан",
                    },
                  ]}
                ></Select>
                {/*<Input rootClassName={classes.formInput}*/}
                {/*       placeholder={"Das Land"}*/}
                {/*/>*/}
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="city"
              >
                <Select
                  placeholder={"Хот/Аймаг"}
                  style={{ width: "100%" }}
                  defaultValue={user?.profile?.city}
                  options={[
                    {
                      value: "Төв аймаг",
                      label: "Төв аймаг",
                    },
                    {
                      value: "Дархан-Уул аймаг",
                      label: "Дархан-Уул аймаг",
                    },
                    {
                      value: "Сонгинохайрхан дүүрэг",
                      label: "Сонгинохайрхан дүүрэг",
                    },
                    {
                      value: "Чингэлтэй дүүрэг",
                      label: "Чингэлтэй дүүрэг",
                    },
                    {
                      value: "Баянгол дүүрэг",
                      label: "Баянгол дүүрэг",
                    },
                    {
                      value: "Сүхбаатар дүүрэг",
                      label: "Сүхбаатар дүүрэг",
                    },
                    {
                      value: "Чингэлтэй дүүрэг",
                      label: "Чингэлтэй дүүрэг",
                    },
                    {
                      value: "Хан-Уул дүүрэг",
                      label: "Хан-Уул дүүрэг",
                    },
                    {
                      value: "Баянзүрх дүүрэг",
                      label: "Баянзүрх дүүрэг",
                    },
                    {
                      value: "Налайх дүүрэг",
                      label: "Налайх дүүрэг",
                    },
                  ]}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="school"
              >
                <Select
                  placeholder={"Сургууль"}
                  style={{ width: "100%" }}
                  defaultValue={user?.profile?.school}
                  options={[
                    {
                      value: "Хүмүүн цогцолбор сургууль",
                      label: "Хүмүүн цогцолбор сургууль",
                    },
                    {
                      value: "Од цогцолбор сургууль",
                      label: "Од цогцолбор сургууль",
                    },
                    {
                      value: "12 дугаар сургууль",
                      label: "12 дугаар сургууль",
                    },
                    {
                      value: "37 дугаар сургууль",
                      label: "37 дугаар сургууль",
                    },
                    {
                      value: "Шинэ эхлэл сургууль",
                      label: "Шинэ эхлэл сургууль",
                    },
                    { value: "2 дугаар сургууль", label: "2 дугаар сургууль" },
                    {
                      value: "20 дугаар сургууль",
                      label: "20 дугаар сургууль",
                    },
                    {
                      value: "23 дугаар сургууль",
                      label: "23 дугаар сургууль",
                    },
                    {
                      value: "32 дугаар сургууль",
                      label: "32 дугаар сургууль",
                    },
                    {
                      value: "33 дугаар сургууль",
                      label: "33 дугаар сургууль",
                    },
                    {
                      value: "38 дугаар сургууль",
                      label: "38 дугаар сургууль",
                    },
                    {
                      value: "44 дүгээр сургууль",
                      label: "44 дүгээр сургууль",
                    },
                    {
                      value: "50 дугаар сургууль",
                      label: "50 дугаар сургууль",
                    },
                    {
                      value: "60 дугаар сургууль",
                      label: "60 дугаар сургууль",
                    },
                    {
                      value: "67 дугаар сургууль",
                      label: "67 дугаар сургууль",
                    },
                    {
                      value: "72 дугаар сургууль",
                      label: "72 дугаар сургууль",
                    },
                    {
                      value: "85 дугаар сургууль",
                      label: "85 дугаар сургууль",
                    },
                    { value: "Голомт сургууль", label: "Голомт сургууль" },
                    {
                      value: "Оюуны ундраа сургууль",
                      label: "Оюуны ундраа сургууль",
                    },
                    {
                      value: "Өсвөрийн зохион бүтээгчдийн ахлах сургууль",
                      label: "Өсвөрийн зохион бүтээгчдийн ахлах сургууль",
                    },
                  ]}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="schoolClass"
              >
                <Select
                  defaultValue={user?.profile?.schoolClass}
                  placeholder={"Анги"}
                  style={{ width: "100%" }}
                  options={[
                    {
                      value: "10",
                      label: "10",
                    },
                    {
                      value: "11",
                      label: "11",
                    },
                    {
                      value: "12",
                      label: "12",
                    },
                  ]}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="languageSkills"
              >
                <Select
                  defaultValue={user?.profile?.languageSkills}
                  placeholder={"Төрөлх хэл"}
                  style={{ width: "100%" }}
                  options={[
                    {
                      value: "МОНГОЛ",
                      label: "МОНГОЛ",
                    },
                    {
                      value: "БУРЯТ",
                      label: "БУРЯТ",
                    },
                    {
                      value: "КАЗАХ",
                      label: "КАЗАХ",
                    },
                    {
                      value: "ТУВА",
                      label: "ТУВА",
                    },
                  ]}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="foreignLanguageSkills"
              >
                <Select
                  placeholder={"Гадаад хэл"}
                  style={{
                    width: "100%",
                  }}
                  defaultValue={user?.profile?.foreignLanguageSkills}
                  options={[
                    {
                      value: "Англи",
                      label: "Англи",
                    },
                    {
                      value: "Герман",
                      label: "Герман",
                    },
                    {
                      value: "Орос",
                      label: "Орос",
                    },
                    {
                      value: "Хятад",
                      label: "Хятад",
                    },
                    {
                      value: "Бусад",
                      label: "Бусад",
                    },
                  ]}
                />
              </FormItem>
              <FormItem className={classes.formInputBlock}>
                <Flex
                  style={{ width: "100%", marginTop: 25 }}
                  align={"center"}
                  justify={"center"}
                >
                  <BlueButton
                    onClick={handleOnUpdateProfile}
                    style={{ width: "100%" }}
                  >
                    Хадгалах
                  </BlueButton>
                </Flex>
              </FormItem>
            </Form>
          </Flex>
        </Flex>
      ),
    },
    {
      label: <Link to={"/logout"}>Гарах</Link>,
      key: "logout",
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  function handleCreateApplication() {
    formApplication
      .validateFields()
      .then(async () => {
        message.loading(<IntlMessage id={"loading"} />, 0);
        let profA = formApplication.getFieldValue("professionPriorityA");
        let profB = formApplication.getFieldValue("professionPriorityB");
        let profC = formApplication.getFieldValue("professionPriorityC");
        console.log(profA, profB, profC);
        await ApplicationService.createApplication(profA, profB, profC)
          .then(() => {
            handleFetchData();
            message.destroy();
            message.success(<IntlMessage id={"success"} />, 5);
            formApplication.resetFields();
            setCurrentMenu("my-application");
          })
          .catch(() => {
            message.destroy();
            message.error(<IntlMessage id={"error"} />, 5);
          });
      })
      .catch(() => {});
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  // eslint-disable-next-line no-unused-vars
  const [hasNextPage, setHasNextPage] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);

  const [initLoading, setInitLoading] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setCurrentPageSize(pageSize);
  };

  async function handleFetchData() {
    setLoading(true);
    await ApplicationService.getApplications(currentPage, currentPageSize)
      .then((r) => {
        setMyApplications(r.data.list);
        setHasNextPage(r.data.hasMore);
      })
      .catch(() => {
        message.destroy();
        message.error(<IntlMessage id={"error"} />, 5);
      })
      .finally(() => {
        setLoading(false);
      });

    await FormService.getMyForm()
      .then((r) => {
        setMyForm(r.data);
      })
      .catch(() => {
        message.error(<IntlMessage id={"error"} />, 5);
      });
  }

  useEffect(() => {
    if (currentPage === 1) {
      if (!initLoading) {
        handleFetchData();
      }
    } else {
      setCurrentPage(1);
    }
  }, [currentPageSize]);

  useEffect(() => {
    handleFetchData();
    setInitLoading(false);
  }, [currentPage]);

  return (
    <Flex
      style={{ width: "100%", position: "relative" }}
      vertical
      align={"center"}
      justify={"flex-start"}
    >
      <Header />
      <Flex
        style={{
          width: "100%",
          paddingTop: 150,
          position: "relative",
          overflow: "hidden",
          paddingBottom: 50,
        }}
        vertical
        align={"center"}
        justify={"flex-start"}
      >
        <Flex
          style={{
            width: "100%",
            maxWidth: 1440,
            minWidth: 1440,
            position: "relative",
          }}
          vertical
          gap={35}
          align={"center"}
          justify={"flex-start"}
        >
          {/* <MyText style={{ fontSize: "2rem", fontWeight: "bold" }}>
            Суралцагчийн талбар
          </MyText> */}
          <Flex
            style={{ width: "100%" }}
            align={"flex-start"}
            justify={"space-between"}
            gap={25}
          >
            <Flex
              style={{
                width: 300,
                backgroundColor: "#fafafa",
                paddingTop: 40,
                paddingBottom: 20,
              }}
              align={"center"}
              justify={"center"}
              vertical
              gap={25}
            >
              {user?.profile?.gender === true ? (
                <>
                  <Image
                    preview={false}
                    width={125}
                    src={profileImgMan}
                    style={{ borderRadius: "50%" }}
                  />
                </>
              ) : (
                <>
                  <Image
                    preview={false}
                    width={125}
                    src={profileImgWoman}
                    style={{ borderRadius: "50%" }}
                  />
                </>
              )}
              {user?.profile?.school}
              <b>
                {user?.profile?.firstName} {user?.profile?.lastName}
              </b>

              <Menu
                style={{
                  width: "100%",
                  backgroundColor: "#fafafa",
                  padding: 20,
                }}
                onClick={(e) => {
                  setCurrentMenu(e.key);
                }}
                selectedKeys={[currentMenu]}
                mode={"vertical"}
                items={items}
              />
            </Flex>
            <Flex
              style={{
                width: "100%",
                backgroundColor: "#fafafa",
                paddingTop: 40,
                paddingBottom: 20,
                position: "relative",
              }}
              align={"center"}
              justify={"center"}
            >
              {items.find((item) => item.key === currentMenu)?.item}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Footer />
    </Flex>
  );
};

export default ProfilePage;
